<template>
	<div id="fjx" v-loading="loading">
		<div class="fjx_main">
			<div class="query_info">
				<!-- 报表类型 -->
				<el-button type="primary" @click="someDel(-1)">批量删除</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column label="选择" width="100" align="center">
						<template slot-scope="scope">
							<div
								:class="scope.row.choosed ? 'choosed' : 'nochoose_square'"
								@click="changeChoosed(scope.$index, scope.row)"
							></div>
						</template>
					</el-table-column>
					<el-table-column prop="SendUName" label="发件人" />
					<el-table-column prop="Title" label="主题">
						<template slot-scope="scope">
							<div class="UmContent">{{ scope.row.Title }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="UmContent" label="内容">
						<template slot-scope="scope">
							<div class="UmContent">{{ scope.row.UmContent }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="CreateTime" label="时间" width="170" />
					<el-table-column prop="Flg" label="状态">
						<template slot-scope="scope">
							<span class="cancelState" v-if="scope.row.property === '已读'">已读</span>
							<span v-if="scope.row.property === '未读'">未读</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" align="center">
						<template slot-scope="scope">
							<span class="to_view" @click="lookDetails(scope.row)">查看</span>
							<span class="to_del" @click="someDel(scope.row.UmId)">删除</span>
						</template>
					</el-table-column>
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.png" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
				<div class="my-paging" v-show="czTableData.length != 0">
					<div class="everyPageShow">每页显示 10 条</div>
					<div class="totalNum">共{{ paginationArray.total }}条</div>

					<el-pagination
						@current-change="handleCurrentChange"
						:page-size="paginationArray.currpageSize"
						layout="prev, pager, next, jumper"
						:total="paginationArray.total"
						background
					/>
				</div>
			</div>
		</div>
		<!-- 详细信息 -->
		<el-dialog title="消息详情" :visible.sync="dialogVisible">
			<div class="details_dialog"><span class="details_left">收件人：</span>{{ detailsInfo.ReceiveUName }}</div>
			<div class="details_dialog">
				<span class="details_left">主题：</span>
				<div class="details_content">{{ detailsInfo.Title }}</div>
			</div>
			<div class="details_dialog">
				<span class="details_left">消息内容：</span>
				<div class="details_content">{{ detailsInfo.UmContent }}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="delDeatils">删除</el-button>
				<el-button class="pop_sure_btn pop_exit" type="primary" plain @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			dialogVisible: false,
			//平台账号
			platformAccount: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [
				{
					choosed: false,
					UmId: 3,
					platformAccount: "123",
					intoMoney: "￥500",
					outMoney: "￥300",
					betMoney: "￥300",
					winning: 0,
					rebates: 0,
					profitLoss: 0,
				},
			],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
			//详情信息
			detailsInfo: "",
		};
	},
	methods: {
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.getSendBoxInfo();
		},
		//改变选中或未选中状态
		changeChoosed(index, row) {
			this.$nextTick(function () {
				this.czTableData[index].choosed = !this.czTableData[index].choosed;
			});
		},
		//查询发件箱的情况
		getSendBoxInfo() {
			let that = this;
			let url = "api/User/GetUserMessageInfo";
			let data = {
				Type: 2,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
			};
			this.loading = true;
			postAjax(url, data)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						//给数据加一个选中或未选中的字段
						for (var i = 0, length = data.Data.rows.length; i < length; i++) {
							data.Data.rows[i].choosed = false;
						}
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		//查看详细信息
		lookDetails(info) {
			this.dialogVisible = true;
			this.detailsInfo = info;
		},
		//查看详细信息的删除
		delDeatils() {
			this.del(this.detailsInfo.UmId);
			this.dialogVisible = false;
		},
		//删除
		someDel(umid) {
			//umid为-1表示批量删除，否则为单个删除
			if (umid == -1) {
				if (this.getChoosedIds()) {
					this.del(this.getChoosedIds());
				} else {
					this.$message.error("请选择需要批量删除的数据");
				}
			} else {
				this.del(umid);
			}
		},
		//删除请求的接口
		del(ids) {
			var that = this;
			let url = "/api/User/DelMessages?ids=" + ids;
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.getSendBoxInfo();
				} else {
					that.$message.error("删除失败");
				}
			});
		},
		//得到已被选中的id
		getChoosedIds() {
			let ids = [];
			for (var i = 0, length = this.czTableData.length; i < length; i++) {
				if (this.czTableData[i].choosed) {
					ids.push(this.czTableData[i].UmId);
				}
			}
			return ids.join(",");
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.getSjxInfo();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
		//是否已读
		formatFlg(row, column) {
			return row[column.property] ? "已读" : "未读";
		},
	},
	mounted() {
		this.getSendBoxInfo();
	},
};
</script>

<style type="scss">
.fjx_main {
	padding: 20px 0px 20px 0;
}

/*未选择的*/
.nochoose_square {
	width: 18px;
	height: 18px;
	border: 1px solid #b3b3b3;
	display: inline-block;
	border-radius: 50%;
	cursor: pointer;
}

.choosed {
	width: 18px;
	height: 18px;
	background-color: #0e78c7;
	border-radius: 50%;
	position: relative;
	cursor: pointer;
}

.choosed::after {
	content: "";
	border: 2px solid #fff;
	border-left: 0;
	border-top: 0;
	height: 8px;
	left: 6px;
	position: absolute;
	top: 3px;
	width: 4px;
	transition: transform 0.15s ease-in 0.05s;
	transform: rotate(45deg) scaleY(1);
	transform-origin: center;
}

.el-table .cell {
	display: flex;
	align-items: center;
	justify-content: center;
}

/*弹窗样式*/
#fjx .details_dialog {
	display: flex;
	align-items: flex-start;
	margin-top: 20px;
	padding-left: 20px;
}

#fjx .details_left {
	width: 100px;
	text-align: right;
}

#fjx .details_content {
	width: 70%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	word-break: break-all;
}

#fjx .UmContent {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoCenter/fjx.vue